<div nz-row [nzGutter]="[16, 24]">
  @for (stat of stats(); track $index) {
  <div nz-col class="gutter-row" [nzSpan]="nzSpan()">
    <etoh-stat-display [stat]="stat"></etoh-stat-display>
  </div>
  }
</div>

<ng-content></ng-content>
